import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteOrder, getOrders } from "../../redux/apiCalls"
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   StyledLink,
   StyledButton,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
} from "./OrderList.styles"

const OrderList = () => {
   const dispatch = useDispatch()
   const orders = useSelector((state) => state.order.orders)

   useEffect(() => {
      getOrders(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deleteOrder(id, dispatch)
   }

   const columns = [
      { field: "orderNumber", headerName: "ID", width: 120 },
      { field: "createdAt", headerName: "Date", width: 200 },
      { field: "userId", headerName: "User", width: 220 },
      {
         field: "totalQuantity",
         headerName: "Qty",
         width: 120,
      },
      {
         field: "amount",
         headerName: "Amount",
         width: 130,
      },
      {
         field: "status",
         headerName: "Status",
         width: 120,
      },
      {
         field: "action",
         headerName: "Action",
         width: 150,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledLink to={"/order/" + params.row._id}>
                     <StyledButton>Edit</StyledButton>
                  </StyledLink>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Orders List</Title>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={orders}
                     columns={columns}
                     getRowId={(row) => row._id}
                     disableSelectionOnClick
                     pageSize={20}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
            </Main>
         </Container>
      </>
   )
}

export default OrderList
